import React from 'react';
import OperationListBerthCallItem from './OperationListBerthCallItem';
import { RotationBerthCall } from 'src/types/ViewModel/Stowage/Rotation/RotationBerthCall';
import { RotationPortCall } from 'src/types/ViewModel/Stowage/Rotation/RotationPortCall';
import { useCargoOperationDragDrop } from '../hooks/useCargoOperationDragDrop';
import { BerthOperations } from '../OperationListView.styles';
import { CargoOperationInfoMenu } from '../../Stowage.styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import BerthOperationListContextMenuWrapper from '../contextMenu/BerthOperationListContextMenuWrapper';

export interface BerthCallsListProps {
    berthCalls: RotationBerthCall[];
    selectedStowageRotationPortCall: RotationPortCall;
    onOpenBerthOperationMenu: (e: React.MouseEvent, berthCall: RotationBerthCall) => void;
}

const OperationListBerthCallsComponent: React.FC<BerthCallsListProps> = ({
    berthCalls,
    selectedStowageRotationPortCall,
    onOpenBerthOperationMenu,
}) => {
    const { handleDrop, handleDragOver } = useCargoOperationDragDrop();

    const onOpenBerthMenu = (e, berthCall: RotationBerthCall) => {
        onOpenBerthOperationMenu(e, berthCall);
    };

    return (
        <>
            {berthCalls.map((bc, i) => (
                <div key={'bc_' + bc.berthCallGuid + '_' + i} onDrop={(e) => handleDrop(e, bc, selectedStowageRotationPortCall)}>
                    <BerthOperations>
                        <span
                            className="berth-name"
                            onDragOver={handleDragOver}
                            onContextMenu={(e) => {
                                e.preventDefault();
                                onOpenBerthMenu(e, bc);
                            }}
                        >
                            {bc.berthName}
                            <CargoOperationInfoMenu onClick={(e) => onOpenBerthMenu(e, bc)} title="Open cargo operation menu">
                                <FontAwesomeIcon icon="ellipsis-h" />
                            </CargoOperationInfoMenu>
                            <BerthOperationListContextMenuWrapper berthCall={bc} key={'new_op_bertcall_' + bc.berthCallGuid} />
                        </span>
                        <OperationListBerthCallItem berthCall={bc} />
                    </BerthOperations>
                </div>
            ))}
        </>
    );
};

export default OperationListBerthCallsComponent;
